module.exports = __webpack_public_path__ + "img/antes_despues_54.25a78a9b.png";